module.exports = __webpack_public_path__ + "assets/Crowding selected.e3b7f30a202cc8a4907f52ade1ead037.png";